import { Component, Inject, Injector, OnInit, ChangeDetectionStrategy, inject, signal } from '@angular/core'
import { FieldTree, form, validate } from '@angular/forms/signals'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { FormValidationService } from 'app/_jaettu-angular/service/form-validation.service'
import { Kayttaja } from 'app/_jaettu-lemonator/model/asiakas'

export interface KirjanpitoAineistonLahetysDialogData {
  vastaanottajat: Kayttaja[]
  sahkopostinTeksti: string
}

export interface KirjanpitoAineistonLahetysDialogResult {
  vastaanottajat: Kayttaja[]
}

interface AineistonLahetysLomake {
  vastaanottajat: boolean[]
}

@Component({
  templateUrl: './kirjanpito-aineiston-lahetys.dialog.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class KirjanpitoAineistonLahetysDialog implements OnInit {
  lomake: FieldTree<AineistonLahetysLomake>
  private readonly _injector = inject(Injector)

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: KirjanpitoAineistonLahetysDialogData,
    private _dialogRef: MatDialogRef<KirjanpitoAineistonLahetysDialog, KirjanpitoAineistonLahetysDialogResult>,
    private _formValidationService: FormValidationService,
  ) {}

  ngOnInit() {
    this.lomake = form(
      signal<AineistonLahetysLomake>({ vastaanottajat: this.data.vastaanottajat.map(() => true) }),
      polku => {
        // Sama sääntö kuin FormValidators.vahintaanValittujaArrayssaValidator, jota ei voi ajaa ilman FormArrayta
        validate(polku.vastaanottajat, ({ value }) => (value().filter(valittu => valittu).length < 1 ? { kind: 'min' } : null))
      },
      { injector: this._injector },
    )
  }

  onkoVirhe<T>(kentta: FieldTree<T>, laji: string): boolean {
    return kentta()
      .errors()
      .some(virhe => virhe.kind === laji)
  }

  peruuta() {
    this._dialogRef.close()
  }

  laheta() {
    if (!this.lomake().valid()) {
      this._formValidationService.merkitseKokoLomakeKosketuksi(this.lomake)
      return
    }

    const vastaanottajat = this.data.vastaanottajat.filter((_, index) => this.lomake().value().vastaanottajat[index])
    this._dialogRef.close({
      vastaanottajat: vastaanottajat,
    })
  }
}
